export default "__VITE_PUBLIC_ASSET__7001f424__"